export const balancePOSData = {
  totalValue: 1200000,
  percentage: 45,
  items: [
    {
      title: "SME",
      icon: "🏪",
      value: 500000,
      valuePercentage: 15,
      count: 12,
      countPercentage: 15,
    },
    {
      title: "Retail",
      icon: "🛍️",
      value: 700000,
      valuePercentage: 15,
      count: 4,
      countPercentage: 12,
    },
  ],
};

export const totalStatusData = [
  {
    title: "SR Balance",
    value: 200000,
    percentage: 15,
  },
  {
    title: "Pending",
    value: 100000,
    percentage: 15,
  },
  {
    title: "Redeemed",
    value: 100000,
    percentage: 15,
  },
];

export const finalTotal = [
  {
    title: "Total TOS",
    value: 16,
  },
  {
    title: "Total TOS Value",
    value: 100000,
  },
];

export const recoveryPendingData = {
  chart: [
    { name: "T1", Recovered: 80, Pending: 150 },
    { name: "T2", Recovered: 100, Pending: 130 },
    { name: "T3", Recovered: 90, Pending: 120 },
    { name: "T1", Recovered: 80, Pending: 150 },
    { name: "T2", Recovered: 100, Pending: 130 },
    { name: "T3", Recovered: 90, Pending: 120 },
    { name: "T1", Recovered: 80, Pending: 150 },
    { name: "T2", Recovered: 100, Pending: 130 },
    { name: "T3", Recovered: 90, Pending: 120 },
    { name: "T1", Recovered: 80, Pending: 150 },
    { name: "T2", Recovered: 100, Pending: 130 },
    { name: "T3", Recovered: 90, Pending: 120 },
    { name: "T1", Recovered: 80, Pending: 150 },
    { name: "T2", Recovered: 100, Pending: 130 },
    { name: "T3", Recovered: 90, Pending: 120 },
    { name: "T1", Recovered: 80, Pending: 150 },
    { name: "T2", Recovered: 100, Pending: 130 },
    { name: "T3", Recovered: 90, Pending: 120 },
    { name: "T1", Recovered: 80, Pending: 150 },
    { name: "T2", Recovered: 100, Pending: 130 },
    { name: "T3", Recovered: 90, Pending: 120 },
  ],
  keys: ["Recovered", "Pending"],
  colors: ["#F2664A", "#5D9BFF"],
};
export const actionCodeCoverageData = {
  chart: [
    {
      name: "T1",
      BP: 20,
      "Third Party": 30,
      OTS: 15,
      Paid: 10,
      CB: 25,
      PPT: 50,
    },
    {
      name: "T2",
      BP: 25,
      "Third Party": 35,
      OTS: 20,
      Paid: 15,
      CB: 20,
      PPT: 40,
    },
    {
      name: "T3",
      BP: 30,
      "Third Party": 25,
      OTS: 18,
      Paid: 12,
      CB: 22,
      PPT: 35,
    },
    {
      name: "T1",
      BP: 22,
      "Third Party": 28,
      OTS: 14,
      Paid: 11,
      CB: 21,
      PPT: 45,
    },
    {
      name: "T2",
      BP: 24,
      "Third Party": 32,
      OTS: 17,
      Paid: 13,
      CB: 23,
      PPT: 38,
    },
    {
      name: "T3",
      BP: 26,
      "Third Party": 29,
      OTS: 16,
      Paid: 14,
      CB: 19,
      PPT: 36,
    },
    {
      name: "T1",
      BP: 23,
      "Third Party": 27,
      OTS: 15,
      Paid: 10,
      CB: 20,
      PPT: 42,
    },
    {
      name: "T2",
      BP: 21,
      "Third Party": 31,
      OTS: 19,
      Paid: 16,
      CB: 18,
      PPT: 39,
    },
    {
      name: "T3",
      BP: 28,
      "Third Party": 33,
      OTS: 21,
      Paid: 17,
      CB: 24,
      PPT: 37,
    },
    {
      name: "T1",
      BP: 22,
      "Third Party": 28,
      OTS: 14,
      Paid: 11,
      CB: 21,
      PPT: 45,
    },
    {
      name: "T2",
      BP: 24,
      "Third Party": 32,
      OTS: 17,
      Paid: 13,
      CB: 23,
      PPT: 38,
    },
    {
      name: "T3",
      BP: 26,
      "Third Party": 29,
      OTS: 16,
      Paid: 14,
      CB: 19,
      PPT: 36,
    },
    {
      name: "T1",
      BP: 23,
      "Third Party": 27,
      OTS: 15,
      Paid: 10,
      CB: 20,
      PPT: 42,
    },
  ],
  keys: ["BP", "Third Party", "OTS", "Paid", "CB", "PPT"],
  colors: ["#F2BF3F", "#00B247", "#E07B16", "#E93C75", "#7C3EE3", "#5D81F3"],
};
export const hmlCategorizationData = {
  chart: [
    { name: "Arjun M", Low: 20, Medium: 30, High: 15 },
    { name: "Rohan S", Low: 25, Medium: 35, High: 20 },
    { name: "Riya J", Low: 30, Medium: 25, High: 20 },
    { name: "Manoj R", Low: 22, Medium: 28, High: 20 },
    { name: "Neha J", Low: 24, Medium: 32, High: 20 },
    { name: "Swati R", Low: 26, Medium: 29, High: 20 },
    { name: "Sneha K", Low: 23, Medium: 27, High: 20 },
    { name: "Isha T", Low: 21, Medium: 31, High: 20 },
    { name: "Mansi r", Low: 28, Medium: 33, High: 20 },
    { name: "Minal R", Low: 22, Medium: 28, High: 20 },
    { name: "Swastika K", Low: 24, Medium: 32, High: 20 },
    { name: "Tina L", Low: 26, Medium: 29, High: 20 },
    { name: "Ruby R", Low: 23, Medium: 27, High: 20 },
  ],
  keys: ["High", "Medium", "Low"],
  colors: ["#E93C75", "#7C3EE3", "#5D81F3"],
};
